export default {
  sections: {
    address: 'Bedrijfsadres',
    address_help: 'Vul het adres in waar uw bedrijf geregistreerd is. Dit wordt op uw facturen afgedrukt.',
  },
  form: {
    legal_form: {
      label: 'Bedrijfstype',
      help: 'Een UG (haftungsbeschränkt) is hier een GmbH, een e.K. een eenmanszaak. Neem voor een OHG of KG contact op met support.',
      options: {
        sole_trader: 'Eenmanszaak',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Geregistreerde bedrijfsnaam',
      placeholder: 'Voer de geregistreerde bedrijfsnaam in',
      sole_trader_help: 'Laat leeg als u onder uw eigen naam handelt',
    },
  },
  buttons: {
    next: 'Volgende',
  },
};
